<template>
  <v-container fluid >
    <v-form @submit="updateStudyGroup">
      <v-card v-if="study_group">
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field label="Name"
                            v-model="study_group.name"
                            color="secondary"
                            type="text"
                            validate-on-blur
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Short Name"
                            v-model="study_group.short_name"
                            color="secondary"
                            type="text"
                            validate-on-blur
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider/>

        <v-card-subtitle class="box-shadow">Dates for recruitment of candidates for the group</v-card-subtitle>
        <v-divider/>
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="6" class="my-0">
              <date-field label=""
                          v-model="study_group.recruitment_period[0]"
                          :error-messages="api_errors['recruitment_period']"
              />
            </v-col>
            <v-col cols="12" md="6" class="my-0">
              <date-field label=""
                          v-model="study_group.recruitment_period[1]"
                          :error-messages="api_errors['recruitment_period']"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider/>
        <v-card-subtitle class="box-shadow">Study period</v-card-subtitle>
        <v-divider/>
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="6" class="my-0">
              <date-field label=""
                          v-model="study_group.study_period[0]"
                          :error-messages="api_errors['study_period']"
              />
            </v-col>
            <v-col cols="12" md="6" class="my-0">
              <date-field label=""
                          v-model="study_group.study_period[1]"
                          :error-messages="api_errors['study_period']"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider/>
        <v-card-subtitle class="box-shadow">Visits filtering end</v-card-subtitle>
        <v-divider/>
        <v-card-text class="py-0">
          <date-field
              v-model="study_group.visits_filtering_end"
              :error-messages="api_errors['visits_filtering_end']"
          />
        </v-card-text>

        <v-divider/>
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-switch label="Members only"
                        v-model="study_group.members_only"
                        false-value="0"
                        :error-messages="api_errors['members_only']"/>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-switch label="Members auto-approve"
                        v-model="study_group.members_auto_approve"
                        false-value="0"
                        :error-messages="api_errors['members_auto_approve']"/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider/>
        <v-card-subtitle class="box-shadow">Booking Policy</v-card-subtitle>
        <vue-editor id="study_group_booking_policy" v-model="study_group.booking_policy" :editor-toolbar="toolbar"></vue-editor>

        <v-divider/>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="$emit('loadStudyGroup')">Revert</v-btn>
          <v-btn color="success" type="submit">Apply</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import DateField from "../../../components/DateField";
export default {
  components: {DateField},
  props: {
    study_group: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    toolbar: [
      [
        { header: [false, 1, 2, 3, 4, 5, 6] },
        "bold", "italic", "underline"
      ],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["link", "formula"],
    ],
    api_errors: []
  }),
  mounted() {
    this.api_errors = []
  },
  methods: {
    updateStudyGroup(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.put(`api/study-groups/${this.$route.params.study_group_id}`, this.study_group)
          .then(() => {
            this.$notify('Success!', 'success')
          })
        .catch(errors => {this.api_errors = errors.response.data.errors})
    }
  }

}
</script>